import {
  faChevronDown,
  faLocationDot,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RootState } from "@store/store";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { getAddressfromOBJS } from "src/helpers/helperFunctions";
import CartDrawer from "../AdminComponents/CartDrawer";
import ManageAddressScreen from "../AllTabs/ManageAddressScreen";

interface DileveryAddressTitleProps {
  onAddressClick?: () => void;
  hasOwnModal?: boolean;
  className?: string;
  name?: string;
}

const DileveryAddressTitle = ({
  onAddressClick,
  hasOwnModal = false,
  className,
  name,
}: DileveryAddressTitleProps) => {
  const { address } = useSelector((state: RootState) => state.cartSlice);
  const [showModal, setShowModal] = useState(false);
  
  return (
    <>
      {hasOwnModal && (
        <CartDrawer isOpen={showModal} onClose={() => setShowModal(false)}>
          <ManageAddressScreen onBack={() => setShowModal(false)} />
        </CartDrawer>
      )}
      <div
        className={`bg-[#F1F5F9] 2xl:p-2 p-1.5 rounded-md flex items-center justify-between text-[#2D2D2D] font-size-15px  2xl:gap-2 gap-1 w-full cursor-pointer ${className}`}
        onClick={() => {
          if (hasOwnModal) {
            setShowModal(true);
          } else {
            onAddressClick?.();
          }
        }}
        id="delivery-address-title"
      >
        <div className="flex items-center 2xl:gap-2 gap-1">
          <FontAwesomeIcon
            icon={faLocationDot}
            className="text-[#2D2D2D] 2xl:pl-2 pl-1"
          />
          <p className="line-clamp-2">
            <span className="font-Poppins-Medium ">{name || "DELIVER TO:"}</span>{" "}
            <span className="font-Poppins-Regular">
              {getAddressfromOBJS(address)}
            </span>
          </p>
        </div>
        <button className="text-[#2D2D2D] hover:text-black 2xl:text-[12px] text-[10px]">
          <FontAwesomeIcon icon={faChevronDown} />
        </button>
      </div>
    </>
  );
};

export default DileveryAddressTitle;
